import { SimpleAncerSmall } from '../button';
import {
  SectionHeadingLarge,
  SectionInnerHeading,
  HeadingDescSmall,
  HeadingDesc,
  HeadingDescVsmall
} from '../Headings';
import './subscriptionPakeges.css';

function SubscriptionPakeges(props) {
  const {
    image,
    subsName,
    subsPrice,
    discountedPrice,
    timePeriod,
    detail,
    status,
    expiryDate,
    btnText,
    subsPointsHeading,
    subsPoints
  } = props;

  return (
    <div className="subscriptionPakeges box">
      <div className="d-flex justify-content-end">
        {image && <img src={image} alt="" />}
      </div>
      <SectionInnerHeading text={subsName} />
      <div className="priceContainer">
        <SectionHeadingLarge text={subsPrice} />
        <HeadingDesc text={discountedPrice} />
      </div>
      <div className="timePeriod">
        <HeadingDescSmall text={timePeriod} />
        <HeadingDescSmall text={detail} />
      </div>
      {status === true ? (
        <div className="currentPlanContainer">
          <HeadingDescVsmall text="current plane" />
          <HeadingDescVsmall text={expiryDate} />
        </div>
      ) : (
        <SimpleAncerSmall text={btnText} />
      )}
      <HeadingDescSmall text={subsPointsHeading} />
      <ul className="subsPoints">{subsPoints}</ul>
    </div>
  );
}

export default SubscriptionPakeges;
